import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

/**
 * Paused 2026-10-22 (FLOW-394): direct applications go through the pre-application.
 *
 * The ONE front-end switch. While `true`, every "Apply for Kickstart Cash" /
 * "Apply for Debtors Finance" / "New Kickstart application" / "New DF facility"
 * entry point is hidden, and a bare `/entity/:id/kickstart/new` or
 * `/entity/:id/df/new` lands on the business's pre-application instead.
 * Resuming a draft that already exists (`?draft=<sid>`, or the in-page form on
 * the detail screens) is never affected — a draft minted by the pre-application's
 * proceed is finished through exactly that route.
 *
 * The server refuses the matching POSTs under the same name,
 * `DIRECT_APPLICATIONS_PAUSED` in `backend/flow_ai/settings.py`. Flip both to
 * lift the pause; nothing was deleted.
 */
export const DIRECT_APPLICATIONS_PAUSED = true;

/** Where a paused direct entry lands: the business's pre-application. */
export function preApplicationLink(entityShortId: string): string[] {
  return ['/entity', entityShortId, 'applications', 'new'];
}

/**
 * On `:id/kickstart/new` and `:id/df/new`: let a resume (`?draft=`) through,
 * send a fresh start to the pre-application while the pause is on.
 */
export const directApplicationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (!DIRECT_APPLICATIONS_PAUSED || route.queryParamMap.has('draft')) {
    return true;
  }
  return inject(Router).createUrlTree(preApplicationLink(route.paramMap.get('id') ?? ''));
};
